module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("AR & TD")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Review runner activity rank by total distance or completed sessions")])])]), _vm._v(" "), _c('div', {
    staticClass: "artd-card artd-filter-card"
  }, [_c('div', {
    staticClass: "artd-card-header"
  }, [_c('span', {
    staticClass: "artd-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 6h18"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 12h10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 18h4"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "artd-card-title-wrap"
  }, [_c('h2', {
    staticClass: "artd-card-title"
  }, [_vm._v("Report Filters")]), _vm._v(" "), _c('p', {
    staticClass: "artd-card-subtitle"
  }, [_vm._v("Choose a date window and ranking metric for the leaderboard")])])]), _vm._v(" "), _c('div', {
    staticClass: "artd-filter-grid"
  }, [_c('div', {
    staticClass: "artd-filter-field"
  }, [_c('label', {
    staticClass: "artd-label"
  }, [_vm._v("Date range")]), _vm._v(" "), _c('date-range-field', {
    model: {
      value: (_vm.rangeData),
      callback: function($$v) {
        _vm.rangeData = $$v
      },
      expression: "rangeData"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "artd-filter-field artd-sort-field"
  }, [_c('label', {
    staticClass: "artd-label",
    attrs: {
      "for": "artd-sort-by"
    }
  }, [_vm._v("Sort by")]), _vm._v(" "), _c('div', {
    staticClass: "artd-select-wrap"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortBy),
      expression: "sortBy"
    }],
    staticClass: "artd-select",
    attrs: {
      "id": "artd-sort-by",
      "name": "sortBy"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sortBy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByChangeHandle]
    }
  }, [_c('option', {
    attrs: {
      "value": "Distance"
    }
  }, [_vm._v("Total Distance")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Sessions"
    }
  }, [_vm._v("# of Sessions")])]), _vm._v(" "), _c('svg', {
    staticClass: "artd-select-icon",
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "m6 9 6 6 6-6"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "artd-card artd-table-card"
  }, [_c('div', {
    staticClass: "artd-card-header artd-card-header--table"
  }, [_c('span', {
    staticClass: "artd-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 6h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 12h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 18h13"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 6h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 12h.01"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3 18h.01"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "artd-card-title-wrap"
  }, [_c('h2', {
    staticClass: "artd-card-title"
  }, [_vm._v("Runner Leaderboard")]), _vm._v(" "), _c('p', {
    staticClass: "artd-card-subtitle"
  }, [_vm._v("Ranked totals for the selected period")])]), _vm._v(" "), _c('span', {
    staticClass: "artd-total-badge"
  }, [_vm._v(_vm._s(_vm.pageTotal || 0) + " runners")])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "artd-table-skeleton"
  }, [_c('div', {
    staticClass: "artd-sk-header"
  }, _vm._l((6), function(n) {
    return _c('div', {
      key: 'artd-sk-head-' + n,
      staticClass: "artd-sk-cell sk-shimmer"
    })
  }), 0), _vm._v(" "), _vm._l((8), function(row) {
    return _c('div', {
      key: 'artd-sk-row-' + row,
      staticClass: "artd-sk-row"
    }, _vm._l((6), function(col) {
      return _c('div', {
        key: 'artd-sk-col-' + row + '-' + col,
        staticClass: "artd-sk-cell sk-shimmer"
      })
    }), 0)
  })], 2) : _c('div', {
    staticClass: "artd-table-wrap"
  }, [(_vm.tableData && _vm.tableData.length) ? _c('table', {
    staticClass: "artd-data-table"
  }, [_c('thead', {
    staticClass: "artd-table-head"
  }, [_c('tr', {
    staticClass: "artd-table-row"
  }, [_c('th', {
    staticClass: "artd-table-cell artd-table-cell--rank"
  }, [_vm._v("Rank")]), _vm._v(" "), _c('th', {
    staticClass: "artd-table-cell artd-table-cell--runner"
  }, [_vm._v("Runner Name")]), _vm._v(" "), _c('th', {
    staticClass: "artd-table-cell artd-table-cell--id"
  }, [_vm._v("Id")]), _vm._v(" "), _c('th', {
    staticClass: "artd-table-cell artd-table-cell--gender"
  }, [_vm._v("Sex")]), _vm._v(" "), _c('th', {
    staticClass: "artd-table-cell artd-table-cell--sessions"
  }, [_vm._v("# of Sessions")]), _vm._v(" "), _c('th', {
    staticClass: "artd-table-cell artd-table-cell--distance"
  }, [_vm._v("Distance(KM)")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "artd-table-body"
  }, _vm._l((_vm.tableData), function(row, rowIndex) {
    return _c('tr', {
      key: row.id || rowIndex,
      staticClass: "artd-table-row"
    }, [_c('td', {
      staticClass: "artd-table-cell artd-table-cell--rank"
    }, [_vm._v(_vm._s((_vm.pageIndex * _vm.pageSize) + rowIndex + 1))]), _vm._v(" "), _c('td', {
      staticClass: "artd-table-cell artd-table-cell--runner"
    }, [_vm._v(_vm._s(row.runnerName))]), _vm._v(" "), _c('td', {
      staticClass: "artd-table-cell artd-table-cell--id"
    }, [_c('a', {
      staticClass: "artd-runner-link",
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openRunnerData(row)
        }
      }
    }, [_vm._v(_vm._s(row.id))])]), _vm._v(" "), _c('td', {
      staticClass: "artd-table-cell artd-table-cell--gender"
    }, [_vm._v(_vm._s(row.gender))]), _vm._v(" "), _c('td', {
      staticClass: "artd-table-cell artd-table-cell--sessions"
    }, [_vm._v(_vm._s(row.Sessions))]), _vm._v(" "), _c('td', {
      staticClass: "artd-table-cell artd-table-cell--distance"
    }, [_vm._v(_vm._s(row.Distance))])])
  }), 0), _vm._v(" "), (_vm.footer && _vm.footer.length) ? _c('tfoot', {
    staticClass: "artd-table-foot"
  }, [_c('tr', {
    staticClass: "artd-table-row"
  }, [_c('td', {
    staticClass: "artd-table-cell artd-table-cell--rank"
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "artd-table-cell artd-table-cell--runner"
  }), _vm._v(" "), _c('td', {
    staticClass: "artd-table-cell artd-table-cell--id"
  }), _vm._v(" "), _c('td', {
    staticClass: "artd-table-cell artd-table-cell--gender"
  }), _vm._v(" "), _c('td', {
    staticClass: "artd-table-cell artd-table-cell--sessions"
  }, [_vm._v(_vm._s(_vm.footer[0][4]))]), _vm._v(" "), _c('td', {
    staticClass: "artd-table-cell artd-table-cell--distance"
  }, [_vm._v(_vm._s(_vm.footer[0][5]))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tableData && _vm.tableData.length === 0) ? _c('div', {
    staticClass: "artd-empty"
  }, [_c('svg', {
    attrs: {
      "width": "30",
      "height": "30",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "8"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m21 21-4.35-4.35"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8 11h6"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "artd-empty-text"
  }, [_vm._v("No runner totals found for this range.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "artd-pagination"
  }, [_c('v-pagination', {
    attrs: {
      "total": _vm.pageTotal,
      "page-size": _vm.pageSize,
      "layout": ['total', 'prev', 'pager', 'next', 'sizer', 'jumper']
    },
    on: {
      "page-change": _vm.pageChange,
      "page-size-change": _vm.pageSizeChange
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66b985a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/AR&TD.vue
// module id = 1719
// module chunks = 2